import './post.scss';

window.ctbHandleShortcode = id => {
    var input = document.querySelector('#ctbFrontShortcode-' + id + ' input');
    var tooltip = document.querySelector('#ctbFrontShortcode-' + id + ' .tooltip');
    input.select();
    input.setSelectionRange(0, 30);
    document.execCommand('copy');
    tooltip.innerHTML = wp.i18n.__('Copied Successfully!', 'countdown-time');
    setTimeout(() => {
        tooltip.innerHTML = wp.i18n.__('Copy To Clipboard', 'countdown-time');
    }, 1500);
}

// function ctbHandleShortcode(id) {
//     var input = document.querySelector('#ctbFrontShortcode-' + id + ' input');
//     var tooltip = document.querySelector('#ctbFrontShortcode-' + id + ' .tooltip');
//     input.select();
//     input.setSelectionRange(0, 30);
//     document.execCommand('copy');
//     tooltip.innerHTML = wp.i18n.__('Copied Successfully!', 'countdown-time');
//     setTimeout(() => {
//         tooltip.innerHTML = wp.i18n.__('Copy To Clipboard', 'countdown-time');
//     }, 1500);
// }